<template>
  <div class="element-list container-fluid bottom-dotted-border margin-Top-Bottom-1Point5Perc">    
    <div class="admin-Panel-Padding">
      <div class="row vertical-align">
        <div class="col-md-1 col-lg-1">
          <img src= "../../assets/images/reorder.svg" class="cursor-pointer img-responsive opacity-point-2 icon-width-height align-center" alt="drag">
        </div>
        <div class="col-md-1 col-lg-1">
          <div class="align-center">
            <div class="element-index-circle-width-height roundered-corner displayFlex" :class="{'background-color-orange' : this.ElementObj.Type === 7}">
              <div class="element-index-font-style widthInherit fontSize17px marginTop2perc" :class="{'font-weight-bold': this.ElementObj.Type === 7, 'fontSize14px': this.ElementObj.Type !== 7 && parseInt(getDisplayIndexLength) < 3, 'fontSize12px' : this.ElementObj.Type !== 7 && parseInt(getDisplayIndexLength) >= 3}">
                {{getStringIndex}}
              </div>
            </div> 
          </div>
        </div>
        <div class="col-md-8 col-lg-8" v-bind:class="{'cursor-pointer': (parseInt(this.ElementObj.Type) !== 1) && (parseInt(this.ElementObj.Type) !== 12)}">
        <div class="row vertical-align">
          <div class="col-sm-1 col-md-1 col-lg-1 ">
            <img :src= "elementImgSrc" class="img-responsive element-icon-width-height" alt="element-icon">
          </div>
          <div class="col-sm-5 col-md-5 col-lg-5 padding-left-0Perc padding-right-0Perc text-align-left orange-text-color">
            <span class="element-type-font-style">{{elementType}} </span> 
            <span v-if="ElementObj.Type !== 7">
              / {{ElementObj.Duration}}
            </span>
            <span class="tooltip1 cursor-default margin-left-2px">
              <img :src= "getIncludeInProgressSrcValue" class="include-in-progress-width-height margin-right-0px" alt="includeInProgressIcon">  
              <span class="tooltiptext1">{{getIncludeInProgressTooltipValue}}</span>
            </span>
            <span class="tooltip1 margin-0px cursor-default" v-if="ElementObj.Type === 7">
              <img :src="bonusIcon" class="include-in-progress-width-height" alt="bonusIcon">  
              <span class="tooltiptext1">{{getIsBonusContentTooltipValue}}</span>
            </span> 
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
          </div>
        </div> 
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-align-left orange-text-color element-name-text-size element-name-style">
            {{ElementObj.Title}}
          </div>
        </div>        
      </div>
      <div class="col-md-1 col-lg-1">
        <img src= "../../assets/images/edit.svg" class="cursor-pointer img-responsive opacity-point-5 icon-width-height align-center" alt="edit" @click="openRespectiveEditOverlay">
        </div>
        <div class="col-md-1 col-lg-1">
          <img src= "../../assets/images/delete.svg" class="cursor-pointer img-responsive opacity-point-5 icon-width-height align-center" alt="delete" v-on:click="setShowConfirmationBoxAsTrue($event,true)">
          <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="ElementObj" v-bind:prefixString="prefixDeleteElementString" v-bind:postfixString="postDeleteElementString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedElement"></confirmation-alert>
        </div>    
      </div>
    </div>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <update-assessment-reflection-discussion-element v-if="selectedEleTypeForUpdate === 2" :ElementObj="ElementObj" @closePopUp="HideCurrentPopUp"></update-assessment-reflection-discussion-element>
    <update-assessment-mcq-element v-if="selectedEleTypeForUpdate === 3" :ElementObj="ElementObj" @closePopUp="HideCurrentPopUp"></update-assessment-mcq-element>
  </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { assessmentJourneyService } from '@/server-util/assessment-journey-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import UpdateAssessmentReflectionDiscussionElement from '@/components/assessment_journey/UpdateAssessmentReflectionDiscussionElement'
import UpdateAssessmentMCQElement from '@/components/assessment_journey/UpdateAssessmentMCQElement'
import reflectionicon from '../../assets/images/reflectionicon.svg'
import mcqicon from '../../assets/images/mcqicon.svg'
import excludeinprogressicon from '../../assets/images/excludeinprogress.svg'
import includeinprogressicon from '../../assets/images/includeinprogress.svg'
import findIndex from 'lodash/findIndex'
export default {
  props: ['ElementObj'],
  name: 'element-list',
  created () {
    this.setElementImageAndType()
  },
  data: function () {
    return {
      includeInProgressTooltip: '',
      isBonusContentTooltip: '',
      includeInProgressSrc: '',
      elementImgSrc: '',
      elementType: '',
      showConfirmationBox: false,
      prefixDeleteElementString: 'Are you sure you want to delete ',
      postDeleteElementString: '?',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      selectedEleTypeForUpdate: -1
    }
  },
  methods: {
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    HideCurrentPopUp (value) {
      // const openOverlay = value.openOverlay
      // const updatedObj = value.updatedObj
      // const operationName = value.operationName
      this.selectedEleTypeForUpdate = -1
      this.$store.state.isOverlayVisible = false
    },
    openRespectiveEditOverlay (event) {
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
      this.selectedEleTypeForUpdate = parseInt(this.ElementObj.Type)
    },
    setShowConfirmationBoxAsTrue: function (event, flagToUpdate) {
      // AK: Used when user pressed delete button to open delete lesson overlay
      this.showConfirmationBox = flagToUpdate
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    deleteSelectedElement (value) {
      // AK: Hide Delete Confirmation Box
      this.showConfirmationBox = false
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.ElementObj.ElementId !== undefined ||
          this.ElementObj.length > 0
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          assessmentJourneyService
            .deleteElement(storeObj.state.access_token, _this.ElementObj.ElementId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.removeCurrentElementFromList(this.ElementObj)
                this.$store.state.isLoading = false
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected Lesson Object is NULL hence declined DELETE OPERATION'
          )
        }
      }
    },
    setElementImageAndType: function () {
      switch (this.ElementObj.Type) {
        case 2:
          this.elementImgSrc = reflectionicon
          this.elementType = 'Reflection'
          break
        case 3:
          this.elementImgSrc = mcqicon
          this.elementType = 'MCQ'
          break
      }
    },
    removeCurrentElementFromList: function (updatedObj) {
      const indexPos = findIndex(this.elementList, (obj) => {
        return obj.ElementId === updatedObj.ElementId && obj.AssessmentId === updatedObj.AssessmentId
      })
      // console.log('updatedObj: ' + indexPos + ' updatedObj: ' + JSON.stringify(updatedObj))
      if (indexPos > -1) {
        this.$store.state.selectedAssessmentElementList.splice(indexPos, 1)
      }
      this.eventHub.$emit('ElementListUpdated', this.$store.state.selectedAssessmentElementList)
      var objToReturn = {
        openOverlay: false,
        updatedObj: updatedObj,
        operationName: 'Delete'
      }
      this.$emit('closePopUp', objToReturn)
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'update-assessment-reflection-discussion-element': UpdateAssessmentReflectionDiscussionElement,
    'update-assessment-mcq-element': UpdateAssessmentMCQElement,
    'loader': Loader
  },
  watch: {
    ElementObj: function (newVal, oldVal) {
      // AK: If element Object changed then set again element Images and its types
      this.setElementImageAndType()
    }
  },
  computed: {
    getStringIndex: {
      get: function () {
        return this.ElementObj.DisplayIndex
      }
    },
    getIncludeInProgressSrcValue: {
      get: function () {
        if (parseInt(this.ElementObj.Type) === 0) {
          this.ElementObj.IncludeInProgress = true
        }
        this.includeInProgressSrc = this.ElementObj.IncludeInProgress ? includeinprogressicon : excludeinprogressicon
        return this.includeInProgressSrc
      }
    },
    getIncludeInProgressTooltipValue: {
      get: function () {
        if (parseInt(this.ElementObj.Type) === 0) {
          this.ElementObj.IncludeInProgress = true
        }
        this.includeInProgressTooltip = this.ElementObj.IncludeInProgress ? constants.Include_In_Progress_True_Tooltip_Text : constants.Include_In_Progress_False_Tooltip_Text
        return this.includeInProgressTooltip
      }
    },
    getIsBonusContentTooltipValue: {
      get: function () {
        this.isBonusContentTooltip = parseInt(this.ElementObj.Type) === 7 ? constants.Is_Bonus_Content_True_Tooltip_Text : constants.Is_Bonus_Content_False_Tooltip_Text
        return this.isBonusContentTooltip
      }
    },
    getDisplayIndexLength: {
      get: function () {
        return parseInt(this.displayIndexLen)
      }
    },
    elementList: {
      get: function () {
        return this.$store.state.selectedAssessmentElementList
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}
.opacity-point-2 {
  opacity: 0.5;
}
.opacity-point-5 {
  opacity: 0.9;
}
.left-icon-div {
  float: left;
  width: 5%;
}
.right-element-duration-div {
  float: right;
  width: 83%;
}
.middle-element-type-name-div {
  margin: 0 auto;
}
.element-type-font-style {
  font-weight: bold;
}
.element-icon-width-height {
  width: 23px;
  height: 14px;
}
.include-in-progress-width-height {
  width: 20px;
  height: 20px;
}
.padding-top-5px {
  padding-top: 5px;
}
.element-index-font-style {
  font-size: 19px;
  color: #ffffff;
}
.element-index-circle-width-height {
  width: 35px;
  height: 35px;
  background-color: #f39c12;
}
.roundered-corner {
  border-radius: 17.5px;
}
.element-list {
  width: 90%;
}
.element-name-style {
  font-weight: lighter;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.icon-width-height {
  width: 18px;
  height: 22px;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.align-center {
  margin: 0 auto !important;
}
.text-align-left {
  text-align: left;
}
.element-name-text-size {
  font-size: 16px;
}
.orange-text-color {
  color: #f39c12;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.padding-right-0Perc{
  padding-right: 0%;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.width-5Perc{
  width: 5%;
}
.float-left{
  float: left;
}
.margin-5Perc {
  margin:5%;
}
.tooltip1 {
    position: relative;
    /* display: inline-block; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    /* width: 133px; */
    width: -webkit-fill-available;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0.5px;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 140%;
    margin-left: -60px;
    font-size: 11px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.margin-right-0px {
  margin-right: 0px;
}
.margin-0px {
  margin: 0px;
}
.margin-left-2px {
  margin-left: 2px;
}
.displayFlex {
  display: flex;
  align-items: center;
}
.fontSize12px {
  font-size: 12px !important;
}
.fontSize14px {
  font-size: 14px !important;
}
.fontSize17px {
  font-size: 17px;
}
.widthInherit {
  width: inherit;
}
.marginTop2perc {
  margin-top:2%;
}
.background-color-orange {
  background-color: #EE6B1F;
}
.font-weight-bold {
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/assessment_journey/AssessmentElementList.vue